import { message } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import i18next from 'i18next';
import React from 'react';
import { bugReportEvents } from './bug-report-context';

const PATCHED_KEY = '__j2lBugHintPatched';

export function installMessageErrorHint(): void {
  if ((message.error as any)[PATCHED_KEY]) return;
  const orig = (message.error as any).bind(message);
  const patched = (...args: any[]) => {
    bugReportEvents.pulse();
    const iconVisible = bugReportEvents.iconVisible();
    const hintText = iconVisible
      ? i18next.t('Puedes reportar este error usando el botón de reporte en la cabecera.')
      : i18next.t('Puedes reportarlo en "Reportar una incidencia" en el pie de página.');
    const hint = iconVisible ? (
      <span style={{ opacity: 0.75, fontSize: '0.9em' }}>
        {i18next.t('Puedes reportar este error usando el ícono')} <BugOutlined /> {i18next.t('en la cabecera.')}
      </span>
    ) : (
      <span style={{ opacity: 0.75, fontSize: '0.9em' }}>{hintText}</span>
    );
    const [first, ...rest] = args;
    if (typeof first === 'string') {
      return orig(
        {
          content: (
            <>
              {first}
              <br />
              {hint}
            </>
          ),
          className: 'j2l-bug-hint-toast'
        },
        ...rest
      );
    }
    if (first && typeof first === 'object' && 'content' in first) {
      return orig(
        {
          ...first,
          content: (
            <>
              {first.content}
              <br />
              {hint}
            </>
          ),
          className: 'j2l-bug-hint-toast'
        },
        ...rest
      );
    }
    return orig(first, ...rest);
  };
  (patched as any)[PATCHED_KEY] = true;
  (message.error as any) = patched;
}
